export const getKey = (key: string) => `p:${key}`;

export const clear = (key: string) => localStorage.removeItem(getKey(key));

export const get = (key: string) => localStorage.getItem(getKey(key));

export const set = (key: string, value: any) => (
  localStorage.setItem(getKey(key), value)
);

export default {
  clear,
  get,
  set,
};
